import React from 'react'

export const texasSetupVars = {
  siteId: 'texas',
  pathPrefix: '/tx',
  menuHeader: "Discover Texas's Solution for:",
  appUrl: 'https://tx.headed2.com',
  logoImg: '/images/assets/texas/horizontal/dark.svg',
  headerTitle: `The Texas CareerExplorer is a system designed for Texas`
}
